<template>
  <v-container fluid>
    <v-toolbar flat color="transparent" class="elevation-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            rounded
            color="primary"
            large
            @click="
              $router.push({
                name: 'Admin',
              })
            "
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>หน้าหลัก</span>
      </v-tooltip>
      <v-toolbar-title class="font-weight-black"> อุปกรณ์ </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-toolbar flat color="elevation-0">
      <v-text-field
        width="100"
        v-model="search"
        hide-details
        prepend-inner-icon="mdi-magnify"
        single-line
        class="shrink"
        label="Search"
        clearable
        filled
        rounded
        dense
      />
      <v-spacer />
      <v-dialog
        persistent
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialog"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn small fab color="primary" v-bind="attrs" v-on="on"
            ><v-icon>mdi-plus</v-icon></v-btn
          >
        </template>
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-toolbar color="primary" dark>รายการอุปกรณ์</v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.device_id"
                      :rules="[rules.required]"
                      label="รหัสอุปกรณ์"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.name"
                      :rules="[rules.required]"
                      label="ชื่ออุปกรณ์"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.description"
                      label="หมายเหตุ"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text color="red" @click="close()">ยกเลิก</v-btn>
              <v-btn
                text
                :loading="saving"
                :disabled="saving"
                color="primary"
                @click="save()"
                >บันทึก</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="desserts"
      :items-per-page="15"
      class="elevation-1"
    >
      <template v-slot:[`header.actions`]="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon dark @click="refresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>อ่านข้อมูลใหม่</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu
          offset-y
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="editItem(item)">
              <v-list-item-title>
                <v-icon class="pr-2"> mdi-pencil </v-icon>
                <span> แก้ไขข้อมูล </span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="deleteItem(item)">
              <v-list-item-title>
                <v-icon color="red" class="pr-2">
                  mdi-trash-can-outline
                </v-icon>
                <span> ลบข้อมูล </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- SNAK BAR -->
    <v-snackbar
      v-model="snackbar.show"
      :vertical="snackbar.vertical"
      :color="snackbar.color"
      timeout="3000"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Rules from "@/InputValidateRules";
export default {
  data: () => ({
    search: "",
    dialog: false,
    valid: false,
    saving: false,
    rules: Rules.rules,
    editedItem: {
      device_id: "",
      name: "",
      description: "",
    },
    defaultItem: {
      device_id: "",
      name: "",
      description: "",
    },
    desserts: [],
    headers: [
      { text: "หมายเลขอุปกรณ์", width: 200, value: "device_id" },
      { text: "ชื่ออุปกรณ์", width: 300, value: "name" },
      { text: "หมายเหตุ", value: "description" },
      { text: "Actions", width: 50, value: "actions", sortable: false },
    ],
    snackbar: {
      show: false,
      text: "",
      color: "success",
      vertical: false,
    },
  }),
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.desserts = await this.$api.WhiteListApi.get();
      console.log("refresh", this.desserts);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },
    editItem(item) {
      console.log(item);
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      this.$confirm("ต้องการลบข้อมูลเดี๋ยวนี้หรือไม่?", {
        title: "Warning",
        color: "warning",
      }).then(async (res) => {
        console.log(res);
        if (res) {
          console.log("DELETE: ", item);
          const result = await this.$api.WhiteListApi.delete(item);
          console.log(result);
          if (result !== undefined) {
            if (result.data.n !== 0) {
              this.desserts.splice(index, 1);
            }
          }
        }
      });
    },
    async save() {
      this.$refs.form.validate();
      console.log("VALID> ", this.valid);
      if (this.valid) {
        try {
          this.saving = true;
          if (this.editedIndex > -1) {
            const result = await this.$api.WhiteListApi.update(this.editedItem);
            console.log(result);
            if (result.result) {
              Object.assign(this.desserts[this.editedIndex], this.editedItem);
            }
          } else {
            const result = await this.$api.WhiteListApi.insert(this.editedItem);
            if (result.result) {
              this.editedItem._id = result.data._id;
              const newObj = Object.assign({}, this.editedItem);
              this.desserts.push(newObj);
            }
          }
          this.close();
        } catch (error) {
          console.log(error);
          this.snackbar.color = "error";
          this.snackbar.text = error.data.description;
          this.snackbar.show = true;
        } finally {
          this.saving = false;
        }
      }
    },
  },
};
</script> 
